import { Row, Col, Checkbox, Button, Text as InputText } from '@mch-group/uikit-components'
import { FC } from 'react'
import classNames from 'classnames'
import { withFormik } from 'formik'
import * as Yup from 'yup'
import CompleteMessage from './CompleteMessage'
import { Text, Uploader } from '@components'
import { PressAcc as PressAccService } from '@services'
import { isApproved, isSubmitted, isFormVisible, isDocsSubmittedEnabled, isNotSuccessfull, getShowPdf } from './utils'
import validationConstants from '@constants/validation'
import ApplicationDocuments from './ApplicationDocuments'
import { useLabelsFromAPI } from '@dmi-mch/hooks'
import { getSiteLanguage } from '@utils/storage'
interface IApplicationFormComponent {
  press: any
  event: any
  mediaAccreditation: any
  handleSubmit: any
  values: any
  errors: any
  isSubmitting: any
  handleChange: any
  handleBlur: any
  touched: any
  mID: any
  props: any
  setFieldValue: any
  setFieldTouched: any
  setFieldError: any
  labels: any
}

const ApplicationFormComponent: FC<IApplicationFormComponent> = ({
  press,
  event,
  mediaAccreditation,
  handleSubmit,
  values,
  errors,
  isSubmitting,
  handleChange,
  handleBlur,
  touched,
  mID,
  labels,
  ...props
}) => {
  const { labels: fieldValidationLabels } = useLabelsFromAPI(['FieldValidation'], getSiteLanguage())
  const editingMode =
    !isApproved(mediaAccreditation?.status) &&
    !isSubmitted(mediaAccreditation?.status) &&
    !isNotSuccessfull(mediaAccreditation?.status)
  const summaryMode = !editingMode

  const onDeleteFile = (fileProps) => {
    props.setFieldValue(fileProps.name, '', true)
  }

  const onFileUploadSuccess = (fileProps, filename, apiResponse) => {
    props.setFieldValue(fileProps.name, apiResponse.url)
  }

  if (!press.validProfile) {
    return (
      <>
        {isFormVisible(press.permanent, mediaAccreditation?.status) && (
          <Row gutter='g-5 g-md-6 g-xl-7' className='pb-0 mb-5 mb-md-5 mb-lg-5 mb-xl-5'>
            <Col>
              <h3 className='h5'>{props.props.mpaa_credentials_info}</h3>
            </Col>
          </Row>
        )}
        <ApplicationDocuments data={props} event={event} />
        <Row gutter='g-5 g-md-6 g-xl-7' className='mt-0'>
          <Col md={12} lg={{ span: 11, offset: 1 }} xl={{ span: 10, offset: 1 }} className='mt-0 mb-7 mb-md-8 mb-xl-9'>
            <CompleteMessage mpapd_complete_profile={props.props.mpaa_complete_profile} />
          </Col>
        </Row>
      </>
    )
  }

  return (
    <>
      {editingMode && (
        <Row gutter='g-5 g-md-6 g-xl-7' className='pb-0 mb-5 mb-md-5 mb-lg-5 mb-xl-5'>
          <Col>
            <h3 className='h5'>{props.props.mpaa_credentials_info}</h3>
          </Col>
        </Row>
      )}

      {editingMode && <ApplicationDocuments data={props} event={event} />}

      {!press.permanent && isFormVisible(press.permanent, mediaAccreditation?.status) && (
        <Row gutter='g-5 g-md-6 g-xl-7' className='mb-3 pb-0 mb-md-3 mb-lg-3 mb-xl-4'>
          <Col>
            <Text forwardedAs='h3' isStrong className={`${mID}__title support-documents-title h5`}>
              {props.props.mpaa_supporting_doc || 'Supporting documents'}
            </Text>
          </Col>
        </Row>
      )}

      {editingMode && (
        <form onSubmit={handleSubmit}>
          {!press.permanent && !isApproved(mediaAccreditation?.status) && (
            <>
              <Row className='pb-0 mb-2 mb-md-7 mb-lg-7 mb-xl-7' gutter='g-5 g-md-6 g-xl-7'>
                <Col>
                  <Text isSmall isHtml forwardedAs='p' className='add-docs-title text-medium'>
                    {props?.props?.mpaa_add_supporting_doc ||
                      'Please add supporting documents that proof your qualification for a press accreditation pass and agree on the terms and conditions.'}
                  </Text>
                </Col>
              </Row>

              <Row className='pb-0 mb-8 mb-md-8 mb-lg-8 mb-xl-8' gutter='g-5 g-md-6 g-xl-7'>
                <Col xs={12} md={12}>
                  <Row gutter='g-5 g-md-6 g-xl-7'>
                    <Col xs={12} md={6}>
                      <p className='text-label-large mb-4 mb-md-0'>
                        {props.props.mpaa_comissioning_letter}{' '}
                        <span className='specs'>{props.props.mpaa_file_specs}</span>
                      </p>
                      <Uploader
                        // @ts-ignore
                        api='/msvc/v1/asset/items/upload/pressaccreditation/letter'
                        accept={'.pdf,.jpg,.jpeg,.png'}
                        maxSize={10485760}
                        uploadOnFileSelect
                        showFileInput
                        defaultInputValue={values.commissioningLetter}
                        onDeleteFile={onDeleteFile}
                        onFileUploadSuccess={onFileUploadSuccess}
                        uploadButtonLabel={props.props.mpaa_upload}
                        name='commissioningLetter'
                        id='commissioningLetter'
                        fileUploaderTheme
                        ariaLabel={props.props.mpaa_comissioning_letter}
                        removeFileLabel={labels?.AltTags?.generalRemoveFile || 'Remove File'}
                        onlyRomanCharsLabel={fieldValidationLabels?.FieldValidation?.onlyRomanCharactersMsg}
                      />
                      {errors.commissioningLetter && touched.commissioningLetter && (
                        <div className='text-danger form-text'>{errors.commissioningLetter}</div>
                      )}
                    </Col>
                  </Row>
                </Col>

                <Col xs={12} md={6}>
                  <Row>
                    <p className='text-label-large mb-4 mb-md-0'>
                      {props.props.mpaa_recent_article_or_article_url}{' '}
                      <span className='specs'>{props.props.mpaa_file_specs}</span>
                    </p>
                  </Row>
                </Col>

                <Col xs={12} md={12}>
                  <Row>
                    <Col xs={12} md={6}>
                      <Uploader
                        // @ts-ignore
                        api='/msvc/v1/asset/items/upload/pressaccreditation/article'
                        accept={'.pdf,.jpg,.jpeg,.png'}
                        maxSize={10485760}
                        uploadOnFileSelect
                        showFileInput
                        defaultInputValue={values.recentArticlePdf}
                        onDeleteFile={onDeleteFile}
                        onFileUploadSuccess={onFileUploadSuccess}
                        uploadButtonLabel={props.props.mpaa_upload}
                        name='recentArticlePdf'
                        id='recentArticlePdf'
                        fileUploaderTheme
                        ariaLabel={props.props.mpaa_recent_article_or_article_url}
                        onlyRomanCharsLabel={fieldValidationLabels?.FieldValidation?.onlyRomanCharactersMsg}
                      />
                      {errors.recentArticlePdf && touched.recentArticlePdf && (
                        <div className='text-danger form-text'>{errors.recentArticlePdf}</div>
                      )}
                    </Col>
                    <Col xs={12} md={6}>
                      <InputText
                        type='text'
                        id='recentArticleWebsite'
                        name='recentArticleWebsite'
                        placeholder='https://'
                        value={values?.recentArticleWebsite || ''}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className='fileuploader'
                        ariaLabel={props.props.mpaa_recent_article_or_article_url}
                      />
                      {errors.recentArticleWebsite && touched.recentArticleWebsite && (
                        <div className='text-danger form-text'>{errors.recentArticleWebsite}</div>
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </>
          )}

          {/* Additional Informations (mandatory for influencer, content creator, broadcaster, photographer) */}
          {!isApproved(mediaAccreditation?.status) && (
            <>
              <Row className='pb-0 mb-4 mb-md-5 mb-lg-6 mb-xl-7' gutter='g-5 g-md-6 g-xl-7'>
                <Col xs={12} md={12} lg={6}>
                  {props.props.mpaa_additional_info_label && (
                    <p className='text-label-large mb-4 mb-md-6'>
                      {props.props.mpaa_additional_info_label}{' '}
                      {props.props.mpaa_additional_info_validation && (
                        <span className='specs'>({props.props.mpaa_additional_info_validation})</span>
                      )}
                    </p>
                  )}
                  <textarea
                    value={values.additionalInformation}
                    name='additionalInformation'
                    maxLength={1000}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    rows={5}
                    className='w-100'
                    aria-label={props.props.mpaa_additional_info_label}
                  ></textarea>
                  {errors.additionalInformation && touched.additionalInformation && (
                    <div className='text-danger form-text'>{errors.additionalInformation}</div>
                  )}
                </Col>
              </Row>
            </>
          )}

          {!isApproved(mediaAccreditation?.status) && (
            <>
              {!press.permanent && (
                <Row className='pb-0 mb-4 mb-md-4 mb-lg-4 mb-xl-4' gutter='g-5 g-md-6 g-xl-7'>
                  <Col xs={12} md={12}>
                    <Text isSmall isHtml forwardedAs='div'>
                      {props.props.mpaa_pr_representative_desc}
                    </Text>
                  </Col>
                </Row>
              )}

              <Row className='pb-0 mb-9 mb-md-9 mb-lg-9 mb-xl-9' gutter='g-5 g-md-6 g-xl-7'>
                <Col xs={12} md={12}>
                  <div className='d-flex agree-tc'>
                    <Checkbox
                      align='right'
                      checked={values.agreeTerms}
                      className='text-medium'
                      onChange={(e) => props.setFieldValue('agreeTerms', e.target.checked)}
                      // @ts-ignore
                      onBlur={() => props.setFieldTouched('agreeTerms')}
                      label={props?.props?.mpaa_agreement}
                      id='agreeTerms'
                      name='agreeTerms'
                    />
                    &nbsp;
                    {props?.props[getShowPdf(event.name, 'termsconditions', 'title')] && (
                      <a
                        href={props?.props[getShowPdf(event.name, 'termsconditions', 'url')]}
                        target='_blank'
                        className='text-inline-link inline-tc'
                      >
                        {props?.props[getShowPdf(event.name, 'termsconditions', 'title')]}
                      </a>
                    )}
                  </div>

                  {errors.agreeTerms && touched.agreeTerms && (
                    <div className='text-danger form-text'>{errors.agreeTerms}</div>
                  )}
                </Col>
              </Row>

              <Row className='pb-0 mb-0 mb-md-7 mb-lg-7 mb-xl-4' gutter='g-5 g-md-6 g-xl-7'>
                <Col xs={12} md={12}>
                  <Button
                    className='mb-8 mb-md-7'
                    variant='primary'
                    type='submit'
                    isLoading={isSubmitting}
                    disabled={isSubmitting}
                  >
                    {props.props.mpaa_submit_app}
                  </Button>
                </Col>
              </Row>
            </>
          )}
        </form>
      )}

      {props.props.mpaa_your_submitted_app &&
        // Application submitted on April 27, 2018
        (summaryMode ? (
          <>
            <Row className='mb-0 pb-0 mb-md-5 mb-lg-5 mb-xl-5' gutter='g-5 g-md-6 g-xl-7'>
              <Col xs={12} md={12}>
                <Text
                  forwardedAs='p'
                  className={classNames(`${mID}__accordion-submitted`, {
                    'press-accreditation-application__accordion-submitted--vip': press.permanent
                  })}
                >
                  {props.props.mpaa_your_submitted_app}
                </Text>
              </Col>
            </Row>
          </>
        ) : null)}
      {
        // Documents and URL submitted in the Press Acc (view mode)
        isDocsSubmittedEnabled(mediaAccreditation?.status, press.permanent) && (
          <>
            {
              // Commission Letter
              mediaAccreditation?.commissioningLetter && (
                <>
                  <Row className='pb-0 mb-5 mb-md-5 mb-lg-5 mb-xl-5' gutter='g-5 g-md-6 g-xl-7'>
                    <Col xs={12} md={12}>
                      <p className='text-label-large mb-2'>{props.props.mpaa_comissioning_letter}</p>
                      <a href={mediaAccreditation?.commissioningLetter} target='_blank' className='text-link truncate'>
                        {mediaAccreditation?.commissioningLetter}
                      </a>
                    </Col>
                  </Row>
                </>
              )
            }
            {
              // Recent Article
              mediaAccreditation?.recentArticlePdf && (
                <>
                  <Row className='pb-0 mb-5 mb-md-5 mb-lg-5 mb-xl-5' gutter='g-5 g-md-6 g-xl-7'>
                    <Col xs={12} md={12}>
                      <p className='text-label-large mb-2'>{props.props.mpaa_recent_article}</p>
                      <a
                        href={mediaAccreditation?.recentArticlePdf}
                        target='_blank'
                        className='text-link truncate'
                        title={mediaAccreditation?.recentArticlePdf}
                      >
                        {mediaAccreditation?.recentArticlePdf}
                      </a>
                    </Col>
                  </Row>
                </>
              )
            }
            {
              // Website / URL
              mediaAccreditation?.recentArticleWebsite && (
                <>
                  <Row className='pb-0 mb-5 mb-md-5 mb-lg-5 mb-xl-5' gutter='g-5 g-md-6 g-xl-7'>
                    <Col xs={12} md={12}>
                      <p className='text-label-large mb-2'>{props.props.mpaa_article_url}</p>
                      <a
                        href={`${mediaAccreditation?.recentArticleWebsite}`}
                        target='_blank'
                        className='text-link truncate'
                        rel='nofollow noopener'
                      >
                        {mediaAccreditation?.recentArticleWebsite}
                      </a>
                    </Col>
                  </Row>
                </>
              )
            }
          </>
        )
      }

      {
        // additionalInformation
        summaryMode && mediaAccreditation?.additionalInformation && (
          <>
            <Row className='pb-0 mb-5 mb-md-5 mb-lg-5 mb-xl-5' gutter='g-5 g-md-6 g-xl-7'>
              <Col xs={12} md={6}>
                <p className='text-label-large mb-2'>{props.props.mpaa_additional_info_summary}</p>
                <p>{mediaAccreditation?.additionalInformation}</p>
              </Col>
            </Row>
          </>
        )
      }
    </>
  )
}

const ApplicationFormik: any = withFormik({
  mapPropsToValues: (props: any) => ({
    eventId: props?.mediaAccreditation?.eventId || null,
    recentArticleWebsite: props?.mediaAccreditation?.recentArticleWebsite,
    recentArticlePdf: props?.mediaAccreditation?.recentArticlePdf,
    commissioningLetter: props?.mediaAccreditation?.commissioningLetter,
    additionalInformation: props?.mediaAccreditation?.additionalInformation,
    agreeTerms: false
  }),
  validationSchema: (props) =>
    Yup.object().shape({
      additionalInformation: Yup.string().test(
        'additionalInformation',
        props.labels.FieldValidation.valmsg_field_required || 'This field is required',
        function validate(value) {
          if (
            // influencer, content creator, broadcaster, photographer
            !value &&
            [102900010, 102900011, 102900012, 102900004].includes(props?.press?.data?.profile?.mediaFunction)
          ) {
            return false // returns the error
          } else {
            return true
          }
        }
      ),
      commissioningLetter: props.press.permanent
        ? Yup.string()
        : Yup.string()
            .required(props.labels.FieldValidation.valmsg_field_required || 'This field is required')
            .nullable(),
      recentArticleWebsite: Yup.string()
        .when('recentArticlePdf', (recentArticlePdf, schema) => {
          const mediaType = props?.press?.data?.profile?.mediaType || ''
          // Broadcast Radio & Broadcast Television
          const requiredMediaTypes = [102900003, 102900004]
          if ((requiredMediaTypes.includes(mediaType) || !recentArticlePdf) && !props.press.permanent) {
            return schema.required(props.labels.FieldValidation.valmsg_field_required || 'This field is required')
          }
          return schema
        })
        .matches(validationConstants.URL, props.labels.FieldValidation.URLNotAccessible || 'Please enter a valid URL.'),
      agreeTerms: Yup.string().oneOf(
        ['true'],
        props.labels.FieldValidation.valmsg_field_required || 'This field is required!'
      ),
      recentArticlePdf: Yup.string()
        .nullable()
        .test(
          'recentArticlePdf',
          props.labels.FieldValidation.valmsg_field_required || 'This field is required',
          function (recentArticlePdf) {
            const mediaType = props?.press?.data?.me?.profile.mediaType || ''
            // Broadcast Radio & Broadcast Television
            const requiredMediaTypes = [102900003, 102900004]
            // @ts-ignore
            const { recentArticleWebsite } = this.options.parent
            if (requiredMediaTypes.includes(mediaType) || (!recentArticleWebsite && !props.press.permanent)) {
              return recentArticlePdf ? true : false
            }
            return true
          }
        )
    }),
  handleSubmit: (values: any, { setSubmitting, props }) => {
    // values to send
    const valuesToSend = { ...values }

    // is new application
    const isNewApplication = valuesToSend.eventId === null
    if (isNewApplication) {
      valuesToSend.eventId = props.event.id
    }

    // switch status to approved in case permanent user
    valuesToSend.status = props?.profile?.permanent ? 102900003 : 102900002 // approved vs submitted
    delete valuesToSend.agreeTerms

    const prepareValues = {
      properties: Object.entries(valuesToSend).map((i) => ({ name: i[0], value: i[1] }))
    }

    // POST method for new application
    if (isNewApplication) {
      PressAccService.postAccreditationItems(prepareValues).then(
        (response) => {
          if (response.ok) {
            props.props.setSubmitApplication(true)
            setSubmitting(false)
          }
        },
        () => {
          setSubmitting(false)
        }
      )
    } else {
      // PUT method to update an application
      PressAccService.putAccreditationItems(prepareValues, props.mediaAccreditation.id).then(
        (response) => {
          if (response.ok) {
            props.props.setSubmitApplication(true)
            setSubmitting(false)
          }
        },
        () => {
          setSubmitting(false)
        }
      )
    }
  },
  displayName: 'AccordionContentForm'
})(ApplicationFormComponent)

interface IApplicationForm {
  statuses: any
  props: any
  press: any
  profile: any
  labels: any
  event: any
  mediaAccreditation: any
}

const ApplicationForm: FC<IApplicationForm> = ({ ...props }) => <ApplicationFormik {...props} />

export default ApplicationForm
